<template>
  <div class="laid-out-select-input">
    <template v-for="(option, key) in options">
      <v-chip
        :key="key"
        label
        :outline="!isSelected(key)"
        :dark="isSelected(key)"
        :color="isSelected(key) ? 'primary' : '#616161'"
        @click="$emit('change', key)"
      >{{ option }}</v-chip>
    </template>
  </div>
</template>

<script>
	export default {
		name: 'LaidOutSelectInput',

		props: {
      options: {
        required: true,
        type: Object
      },

      value: {
        required: false,
        type: [Number, String]
      }
    },
    methods: {
      isSelected (optionValue) {
        return Number(this.value) === Number(optionValue)
      }
    }
	}
</script>

<style lang="scss">
  @import '@/styles/components/laidOutSelectInput.scss';
</style>